import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() {
  }

  setSessionStorage(name: string, data: any) {
    sessionStorage.setItem(name, JSON.stringify(data));
  }

  getSessionStorage(name: string): any {
    let data = null;
    if (sessionStorage.getItem(name)) {
      data = JSON.parse(sessionStorage.getItem(name));
    }
    return data;
  }
}
